import { ResponseError } from '../pages/api/auth/types.js';

export const createGetFetch = <
  Req extends string[][] | Record<string, string> | string | URLSearchParams,
  Res,
  Err extends ResponseError = ResponseError,
>(
  endpoint: string,
) => {
  return async (req: Req): Promise<Res> => {
    const params = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const qs = new URLSearchParams(req).toString();
    const res = await fetch(`${endpoint}?${qs}`, params);
    if (res.ok) {
      return (await res.json()) as Res;
    } else {
      const data = (await res.json()) as Err;
      throw new Error(data.error?.message || 'Неопределенная ошибка');
    }
  };
};

export const createPostFetch = <
  Req,
  Res,
  Err extends ResponseError = ResponseError,
>(
  endpoint: string,
) => {
  return async (req: Req): Promise<Res> => {
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req),
    };
    const res = await fetch(endpoint, params);
    if (res.ok) {
      return (await res.json()) as Res;
    } else {
      const data = (await res.json()) as Err;
      throw new Error(data.error?.message || 'Неопределенная ошибка');
    }
  };
};
